import React, { Component } from 'react';

import TooltipWrapper from '../common/form/TooltipWrapper';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '../common/form/button';
import { testarConexao, reset, enviarRelogioControlador, getSincronizacao } from './controladorActions';
import { toastr } from 'react-redux-toastr';
import PermissaoUsuario from '../auth/permissao';
import { Field } from 'redux-form';
import labelAndInput from '../common/form/labelAndInput';
import ActionConfirmModal from '../common/components/actionConfirmModal';
import ProcessingOverlay from '../common/components/processingOverlay';

class ControladorConexao extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      showResetConfirm: false,
      resetEnderecoUDP: null,
      loadingAction: 'reset',
    };

    this.testeManualRealizado = false;
    this.confirmarReset = this.confirmarReset.bind(this);
    this.cancelarReset = this.cancelarReset.bind(this);
  }

  handleClose() {
    this.setState({ show: false });
  }

  getConexao(enderecoUDP) {
    const versaoAntesTeste = window.$('#versaoMCPControlador').val();
    window.$('#versaoMCPControlador').val('Conectando...');

    this.buscarDadosSincronizacao();

    this.props
      .testarConexao(enderecoUDP, this.props.numCont)
      .then(result => {
        const resp = result.payload.data || {};
        const relogioOk = resp.relogio_ok === true;
        const versaoOk = resp.versao_ok === true;
        const portaOk = resp.porta_ok === true;

        if (versaoOk && resp.versao_mcp) {
          window.$('#versaoMCPControlador').val(resp.versao_mcp);
        } else if (versaoAntesTeste && versaoAntesTeste !== 'Conectando...') {
          window.$('#versaoMCPControlador').val(versaoAntesTeste);
        }

        if (relogioOk && resp.data && resp.hora) {
          const valorAtualAnterior = window.$('#dataHoraAtual').val();
          if (
            valorAtualAnterior &&
            valorAtualAnterior !== 'Clique em "Testar Conexão"' &&
            valorAtualAnterior !== 'Sem conexão'
          ) {
            window.$('#dataHoraAnterior').val(valorAtualAnterior);
          }

          const dataHoraAtual = resp.data + '  ' + resp.hora;
          window.$('#dataHoraAtual').val(dataHoraAtual);
          window.$('#dataHoraAtual').css('background-color', '#d4edda');
          this.testeManualRealizado = true;
        } else if (resp.conexao !== false) {
          toastr.warning(
            'Conexão instável',
            'O controlador respondeu, mas a leitura do relógio não foi confiável. Tente novamente. A data da última verificação não foi atualizada.',
          );
        }

        if (resp.pluviometro_ok && resp.hasOwnProperty('temPluviometro') && this.props.change) {
          this.props.change('pluviometrico_ativo', Boolean(resp.temPluviometro));
        }

        window.$('#btnTestarConexao').removeClass('btn-default');
        window.$('#btnTestarConexao').removeClass('btn-warning');
        window.$('#btnTestarConexao').addClass('btn-success');
        window.$('#statusConexaoCont').html('<b>Status:</b> Online');

        if (
          portaOk &&
          resp.porta_enviada != null &&
          resp.porta_controlador != null &&
          resp.porta_enviada !== resp.porta_controlador
        ) {
          toastr.warning(
            'Alerta',
            'A porta enviada ' +
              resp.porta_enviada +
              ' não confere com a porta ' +
              resp.porta_controlador +
              ' encontrada no controlador. Será alterado automaticamente.',
          );

          this.props.change('porta', resp.porta_controlador);
        }

        if (relogioOk && this.props.onEquipamentoSincronizado) {
          this.props.onEquipamentoSincronizado();
        }
      })
      .catch(e => {
        window.$('#versaoMCPControlador').val('Sem conexão');
        window.$('#dataHoraAtual').val('Sem conexão');
        window.$('#dataHoraAtual').css('background-color', '#f8d7da');
        window.$('#statusConexaoCont').html('<b>Status:</b> Offline');

        window.$('#btnTestarConexao').removeClass('btn-default');
        window.$('#btnTestarConexao').removeClass('btn-success');
        window.$('#btnTestarConexao').addClass('btn-warning');
        toastr.error('Erro', 'Sem conexão. O número ou endereço do controlador podem estar errados.');
      });
  }

  buscarDadosSincronizacao() {
    if (this.props.controladorId) {
      getSincronizacao(this.props.controladorId)
        .then(response => {
          const sincronizacao = response.data;

          if (sincronizacao.anterior && sincronizacao.anterior.dataHora) {
            window.$('#dataHoraAnterior').val(sincronizacao.anterior.dataHora);
          } else {
            window.$('#dataHoraAnterior').val('Nenhum registro');
          }

          if (sincronizacao.ultimo && sincronizacao.ultimo.dataHora && !this.testeManualRealizado) {
            window.$('#dataHoraAtual').val(sincronizacao.ultimo.dataHora);
            window.$('#dataHoraAtual').css('background-color', '#e2e3e5');
          }
        })
        .catch(error => {
          console.error('Erro ao buscar dados de sincronização:', error);
          window.$('#dataHoraAnterior').val('Erro ao carregar');
        });
    } else {
      window.$('#dataHoraAnterior').val('Selecione um controlador');
    }
  }

  componentDidMount() {
    if (this.props.controladorId) {
      window.$('#dataHoraAnterior').val('Carregando...');
      window.$('#dataHoraAtual').val('Carregando...');
      window.$('#dataHoraAtual').css('background-color', '#e2e3e5');

      this.buscarDadosSincronizacao();
    } else {
      window.$('#dataHoraAnterior').val('Selecione um controlador');
      window.$('#dataHoraAtual').val('Selecione um controlador');
      window.$('#dataHoraAtual').css('background-color', '#e2e3e5');
    }

    this.intervalId = setInterval(() => {
      this.buscarDadosSincronizacao();
    }, 30000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.controladorId !== this.props.controladorId) {
      this.testeManualRealizado = false;

      if (this.props.controladorId) {
        window.$('#dataHoraAnterior').val('Carregando...');
        window.$('#dataHoraAtual').val('Carregando...');
        window.$('#dataHoraAtual').css('background-color', '#e2e3e5');

        this.buscarDadosSincronizacao();
      } else {
        window.$('#dataHoraAnterior').val('Selecione um controlador');
        window.$('#dataHoraAtual').val('Selecione um controlador');
        window.$('#dataHoraAtual').css('background-color', '#e2e3e5');
      }
    }
  }

  reset(enderecoUDP) {
    this.setState({ showResetConfirm: true, resetEnderecoUDP: enderecoUDP });
  }

  confirmarReset() {
    const enderecoUDP = this.state.resetEnderecoUDP;
    if (!enderecoUDP) return;

    this.setState({ showResetConfirm: false, show: true, resetEnderecoUDP: null, loadingAction: 'reset' });

    this.props
      .reset(enderecoUDP, this.props.numCont)
      .then(result => {
        this.setState({ show: false });
        toastr.success('Sucesso!', result.payload.data);
      })
      .catch(e => {
        this.setState({ show: false });
        toastr.error('Erro', 'Sem conexão. O número ou endereço do controlador podem estar errados.');
      });
  }

  cancelarReset() {
    this.setState({ showResetConfirm: false, resetEnderecoUDP: null });
  }

  enviarRelogio(enderecoUDP) {
    this.setState({ show: true, loadingAction: 'relogio' });

    this.props
      .enviarRelogioControlador(enderecoUDP, this.props.numCont)
      .then(result => {
        this.setState({ show: false });

        if (result.error) {
          toastr.error('Erro', result.payload.response.data.errors[0]);
        } else {
          toastr.success('Sucesso', 'Operação Realizada com sucesso.');

          setTimeout(() => {
            this.getConexao(enderecoUDP);
          }, 1000);
        }
      })
      .catch(e => {
        this.setState({ show: false });
        toastr.error('Erro', e);
      });
  }

  renderLoadingMessage() {
    if (this.state.loadingAction === 'relogio') {
      return (
        <>
          Enviando data/hora para o controlador...
          <small>Aguarde, sincronizando relógio do equipamento.</small>
        </>
      );
    }

    return (
      <>
        Resetando controlador...
        <small>Aguarde, comunicando com o equipamento.</small>
      </>
    );
  }

  render() {
    const enderecoUDP = this.props.udp || [];

    return (
      <>
        <ProcessingOverlay
          show={this.state.show}
          message={this.renderLoadingMessage()}
          tagline="Comunicação"
        />

        <ActionConfirmModal
          show={this.state.showResetConfirm}
          title="Atenção"
          message="Deseja resetar o controlador?"
          confirmLabel="OK"
          icon="exclamation-triangle"
          destructive
          onConfirm={this.confirmarReset}
          onCancel={this.cancelarReset}
        />

        <Field
          name="ip"
          component={labelAndInput}
          ref="controladorip"
          label="IP do Controlador*"
          cols="12 4"
          placeholder="Informe o IP"
          validate={this.props.required}
          readOnly={this.props.readOnly('CadControlador', 'ip_porta_controlador')}
        />

        <Field
          name="porta"
          id="porta"
          component={labelAndInput}
          label="Porta do Controlador*"
          cols="12 4"
          placeholder="Informe a porta"
          validate={this.props.required}
          readOnly={this.props.readOnly('CadControlador', 'ip_porta_controlador')}
        />

        <div className="col-xs-12 col-sm-2">
          <div className="form-group form-group-sm controlador-conexao-action-group">
            <label className="label-gt" id="statusConexaoCont">
              Status:
            </label>

            <PermissaoUsuario tela="CadControlador" campo="testar_conexao" condicao={true}>
              <Button
                type="button"
                id="btnTestarConexao"
                className="primary form-control"
                icon="plug"
                label="Testar Conexão"
                onClick={() => this.getConexao(enderecoUDP)}
              />
            </PermissaoUsuario>

            <PermissaoUsuario tela="CadControlador" campo="testar_conexao" condicao={false}>
              <Button
                type="button"
                id="btnTestarConexao"
                className="primary form-control"
                icon="plug"
                label="Testar Conexão"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </div>
        </div>

        <div className="col-xs-12 col-sm-2">
          <div className="form-group form-group-sm controlador-conexao-action-group">
            <label className="label-gt controlador-premium-action-spacer" aria-hidden="true">
              &nbsp;
            </label>
            <PermissaoUsuario tela="CadControlador" campo="resetar_controlador" condicao={true}>
              <Button
                type="button"
                id="btnResetar"
                className="danger form-control"
                icon="power-off"
                label="Resetar"
                onClick={() => this.reset(enderecoUDP)}
              />
            </PermissaoUsuario>

            <PermissaoUsuario tela="CadControlador" campo="resetar_controlador" condicao={false}>
              <Button
                type="button"
                id="btnResetar"
                className="danger form-control"
                icon="power-off"
                label="Resetar"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </div>
        </div>

        <Field
          name="dataHoraAnterior"
          id="dataHoraAnterior"
          component={labelAndInput}
          label={
            <TooltipWrapper tooltipText="Penúltima verificação realizada pela central (5 minutos atrás)">
              <span>
                Data/Hora <small style={{ fontWeight: '600' }}>Verificação Anterior</small>
              </span>
            </TooltipWrapper>
          }
          tooltipText="Atualizado automaticamente pela central a cada 5 minutos"
          uncontrolledWhenReadOnly={true}
          cols="6 3"
          readOnly={true}
        />
        <Field
          name="dataHoraAtual"
          id="dataHoraAtual"
          component={labelAndInput}
          label={
            <TooltipWrapper tooltipText="Última verificação realizada pela central (5 minutos atrás) ou teste manual">
              <span>
                Data/Hora <small style={{ fontWeight: '600' }}>Última Verificação</small>
              </span>
            </TooltipWrapper>
          }
          uncontrolledWhenReadOnly={true}
          cols="6 3"
          readOnly={true}
        />
        <Field
          name="versaoMCPControlador"
          id="versaoMCPControlador"
          component={labelAndInput}
          label="Versão da MCP"
          uncontrolledWhenReadOnly={true}
          cols="6 3"
          readOnly={true}
        />

        <div className="col-xs-12 col-sm-3">
          <div className="form-group form-group-sm">
            <div>
              <b>&nbsp;</b>
            </div>
            <PermissaoUsuario tela="CadControlador" campo="enviar_relogio" condicao={true}>
              <Button
                type="button"
                id="btnEnviarRelogioControlador"
                className="primary form-control"
                icon="arrow-up"
                label="Enviar Data/Hora"
                onClick={() => this.enviarRelogio(enderecoUDP)}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadControlador" campo="enviar_relogio" condicao={false}>
              <Button
                type="button"
                id="btnEnviarRelogioControlador"
                className="primary form-control"
                icon="arrow-up"
                label="Enviar Data/Hora"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ testarConexao, reset, enviarRelogioControlador }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(ControladorConexao);
